/* TENSO — gift options in the bag.

   Pairs with snippets/gift-options.liquid, which explains the four cart
   attributes and the two paths they take to the order. In short:

     typing         → saved to /cart/update.js, debounced      (for Apple Pay)
     wallet touch   → any pending save is sent at once           (for Apple Pay)
     Checkout       → values written into the form as hidden
                      attributes[...] inputs, then it posts       (no race)

   The switch and the fields are shown and hidden by CSS alone. Nothing here
   decides whether content exists; it only checks, mirrors and saves.

   The block can be on a page twice, the bag page and the drawer (which every
   template renders), so each edit is mirrored to the other copy. Both copies
   load this file, so it guards against running twice.
*/
(function(){
  "use strict";
  if(window.TensoGift) return;

  var FIELDS = ['Gift for', 'Gift mobile', 'Gift message'];
  var DELAY  = 500;
  var timer  = null;
  var pending = null;

  function root(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function blocks(){ return [].slice.call(document.querySelectorAll('[data-gift]')); }
  function field(block, key){ return block.querySelector('[data-gift-field="' + key + '"]'); }
  function raw(block, key){ var el = field(block, key); return el ? el.value : ''; }
  function isOn(block){ var c = block.querySelector('[data-gift-on]'); return !!(c && c.checked); }

  /* Arabic keyboards type ٠١٢…٩, and Persian ones ۰۱۲…۹. Both are folded to
     0–9 before anything is checked or saved. */
  function western(s){
    return String(s).replace(/[٠-٩۰-۹]/g, function(d){
      var c = d.charCodeAt(0);
      return String(c - (c >= 0x06F0 ? 0x06F0 : 0x0660));
    });
  }

  /* A Saudi mobile in any of the ways people write one (05…, 5…, 9665…,
     +9665…, 009665…, with spaces or dashes) comes back as 05XXXXXXXX, the
     form the team dials. Anything else comes back null. */
  function mobile(s){
    var d = western(s).replace(/\D/g, '').replace(/^00/, '');
    if(/^9665\d{8}$/.test(d)) return '0' + d.slice(3);
    if(/^05\d{8}$/.test(d))   return d;
    if(/^5\d{8}$/.test(d))    return '0' + d;
    return null;
  }

  /* What the order should say right now. Switched off sends blanks, which is
     how the cart API removes an attribute, so turning the gift off clears it
     from the order rather than leaving a half-filled one behind. */
  function payload(block){
    var on = isOn(block);
    var m  = raw(block, 'Gift mobile').trim();
    return {
      'Gift':         on ? 'Yes' : '',
      'Gift for':     on ? raw(block, 'Gift for').trim() : '',
      'Gift mobile':  on ? (mobile(m) || western(m)) : '',
      'Gift message': on ? raw(block, 'Gift message').trim() : ''
    };
  }

  /* ---------- saving ---------- */

  function send(block){
    clearTimeout(timer);
    timer = null;
    pending = null;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: payload(block) })
    }).catch(function(){ /* the Checkout path still carries the values */ });
  }

  function save(block, now){
    clearTimeout(timer);
    pending = block;
    if(now) send(block);
    else timer = setTimeout(function(){ send(block); }, DELAY);
  }

  function flush(){ if(pending) send(pending); }

  /* ---------- the other copy ---------- */

  function count(block){
    var out = block.querySelector('[data-gift-count]');
    if(out) out.textContent = raw(block, 'Gift message').length;
  }

  function mirror(from){
    blocks().forEach(function(b){
      if(b === from) return;
      var c = b.querySelector('[data-gift-on]');
      if(c) c.checked = isOn(from);
      FIELDS.forEach(function(k){ var el = field(b, k); if(el) el.value = raw(from, k); });
      count(b);
    });
  }

  /* ---------- checking ---------- */

  function flag(block, key, bad){
    var el  = field(block, key);
    var err = block.querySelector('[data-gift-err="' + key + '"]');
    if(el) el.setAttribute('aria-invalid', bad ? 'true' : 'false');
    if(err) err.hidden = !bad;
  }

  /* Name and mobile are what the team needs to arrange delivery. The message
     may be left empty. Returns the first field to fix, or null. */
  function check(block){
    var nameBad = !raw(block, 'Gift for').trim();
    var mobBad  = !mobile(raw(block, 'Gift mobile'));
    flag(block, 'Gift for', nameBad);
    flag(block, 'Gift mobile', mobBad);
    if(nameBad) return field(block, 'Gift for');
    if(mobBad)  return field(block, 'Gift mobile');
    return null;
  }

  /* Replaces, never appends: after a Back from checkout the page can come out
     of the back/forward cache with the last set still in the form. */
  function write(form, values){
    [].slice.call(form.querySelectorAll('input[data-gift-hidden]')).forEach(function(n){
      n.parentNode.removeChild(n);
    });
    Object.keys(values).forEach(function(k){
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'attributes[' + k + ']';
      i.value = values[k];
      i.setAttribute('data-gift-hidden', '');
      form.appendChild(i);
    });
  }

  /* ---------- events, all delegated ----------
     Delegated to document because the drawer is re-rendered around this
     block; a listener bound to a node near it could be lost in a swap. */

  document.addEventListener('change', function(e){
    var t = e.target;
    var block = t && t.closest && t.closest('[data-gift]');
    if(!block) return;

    if(t.hasAttribute('data-gift-on')){
      if(!t.checked) FIELDS.forEach(function(k){ flag(block, k, false); });
      mirror(block);
      save(block, true);
      if(t.checked){
        var f = block.querySelector('.gift__fields');
        if(f && f.scrollIntoView) f.scrollIntoView({ block: 'nearest' });
      }
      return;
    }
    /* a field's change fires on blur: the shopper has finished with it */
    if(t.hasAttribute('data-gift-field')) save(block, true);
  });

  document.addEventListener('input', function(e){
    var t = e.target;
    var block = t && t.closest && t.closest('[data-gift]');
    if(!block || !t.hasAttribute('data-gift-field')) return;
    if(t.getAttribute('aria-invalid') === 'true') flag(block, t.getAttribute('data-gift-field'), false);
    count(block);
    mirror(block);
    save(block, false);
  });

  /* Apple Pay lives in a closed shadow root, but a touch on it still reaches
     document in the capture phase, retargeted to the host element. */
  document.addEventListener('pointerdown', function(e){
    var t = e.target;
    if(t && t.closest && t.closest('.cd__wallet, .cart__wallet')) flush();
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
    var scope = form.closest('.drawer, .cart');
    var block = scope && scope.querySelector('[data-gift]');
    if(!block) return;

    if(isOn(block)){
      var bad = check(block);
      if(bad){
        e.preventDefault();
        bad.scrollIntoView({ block: 'center' });
        bad.focus({ preventScroll: true });
        return;
      }
    }
    clearTimeout(timer);
    pending = null;
    write(form, payload(block));
  }, true);

  blocks().forEach(count);

  window.TensoGift = { mobile: mobile, payload: payload, flush: flush };
})();
